import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { tap } from 'rxjs';
import { Utility } from '../../core/utils/utility';

@Injectable({
  providedIn: 'root'
})
export class TeacherService {


  constructor(private http: HttpClient) {
  }

  get(filter: any | null = null) {
    let params = new HttpParams();
    for (const key in filter) {
      if (filter[key])
        params = params.append(key, filter[key]);
    }

    return this.http.get(`${environment.apiUrl}/Teacher`, { params: params })
  }

  getById(teacherId: number) {
    return this.http.get(`${environment.apiUrl}/Teacher/GetById?Id=${teacherId}`).pipe(
      tap((x: any) => {
        if (x.profileImageUrl && !x.profileImageUrl.startsWith('http')) {
          x.profileImageUrl = environment.fileServerUrl + x.profileImageUrl;
        }

        x.courses.forEach((element: any) => {
          if (element.coverImageUrl && !element.coverImageUrl.startsWith('http')) {
            element.coverImageUrl = environment.fileServerUrl + element.coverImageUrl;
          }
        });
      })
    )
  }

  delete(teacherId: number) {
    return this.http.delete(`${environment.apiUrl}/InnovationTeacher?Id=${teacherId}`)
  }

  add(value: any) {
    return this.http.post(`${environment.apiUrl}/InnovationTeacher`, value);
  }

  create(value: any) {
    let formData = Utility.objectToFormData(value);

    let options = {
      headers: new HttpHeaders({
        "x-none": "true",
        "enctype": "multipart/form-data",
      }),
    };

    return this.http.post(`${environment.apiUrl}/Teacher`, formData, options);
  }

  update(value: any) {
    return this.http.put(`${environment.apiUrl}/InnovationTeacher`, value);
  }

  getByIds(teacherListId: any = []) {
    let params = new HttpParams();
    if (teacherListId.length) {
      teacherListId.forEach((item: any) => {
        params = params.append('Ids', item);
      });
    }

    return this.http.get(`${environment.apiUrl}/Teacher/GetByIds`, { params: params }).pipe(
      tap((res: any) => {
        res.forEach((x: any) => {
          if (x.profileImageUrl && !x.profileImageUrl.startsWith('http')) {
            x.profileImageUrl = environment.fileServerUrl + x.profileImageUrl;
          }
        });
      })
    )
  }
}
